import type { MetricName } from '../shared_types/modbus_types'
import type { Metric } from '../shared_types/vessel_data'

export const initializeMetrics = (keys: MetricName[], value = 0) => {
  const timestamp = new Date().toISOString()
  const state = {} as Record<string, Metric>
  for (const key of keys) {
    state[key] = { value, timestamp }
  }
  return state
}
